// extracted by mini-css-extract-plugin
export default {"Checkbox":"styles_Checkbox__YMMLg","input":"styles_input__GVibX","label":"styles_label__k6KEZ"};